const config = {
    'neuhofer.h5.software': {
        backendBaseUrl: 'https://neuhofer.h5.software/api/v1/',
        I18N_LOCALE: 'de',
        I18N_FALLBACK_LOCALE: 'en',
        stage: 'prod'
    },
    'neuhoferdev.h5.software': {
        backendBaseUrl: 'https://neuhoferdev.h5.software/api/v1/',
        I18N_LOCALE: 'de',
        I18N_FALLBACK_LOCALE: 'en',
        stage: 'acc'
    },
    localhost: {
        backendBaseUrl: 'http://localhost:3000/api/v1/',
        I18N_LOCALE: 'de',
        I18N_FALLBACK_LOCALE: 'en',
        stage: 'local'
    },
};
export default config;
